module.exports = __webpack_public_path__ + "img/FI21929775.d370a7a6.png";